/**
 * Gate screen for G1–G4: scan → status accepted | held | refused | PENDING.
 */
import React, { useState } from 'react';
import ScanInput from './ScanInput';
import StationLayout from './StationLayout';
import { displayStatus, isDisplayedAsAccepted } from '../offline/outbox';

const GATES = [
  { id: 'G1', label: 'Receive' },
  { id: 'G2', label: 'Put away' },
  { id: 'G3', label: 'Issue to batch' },
  { id: 'G4', label: 'Produce' },
];

export default function GateScreen({
  gate = 'G1',
  onSubmitScan,
  recent = [],
}) {
  const [last, setLast] = useState(null);
  const meta = GATES.find((g) => g.id === gate) || GATES[0];

  const handleScan = async (code) => {
    const event = await onSubmitScan({ gate, code });
    setLast(event);
  };

  const statusLabel = last
    ? last.pending
      ? 'PENDING'
      : last.result || displayStatus(last)
    : null;

  return (
    <StationLayout
      title={`${meta.id} · ${meta.label}`}
      queue={
        <ul data-testid="gate-recent">
          {recent.map((row) => (
            <li key={row.command_id || row.id} data-testid={`gate-row-${row.command_id || row.id}`}>
              <span>{row.code}</span>
              <span data-status={displayStatus(row)}>
                {row.pending ? 'PENDING' : displayStatus(row) || row.result}
              </span>
              {isDisplayedAsAccepted(row) && row.pending ? (
                <span data-testid="bad-accepted">accepted</span>
              ) : null}
            </li>
          ))}
        </ul>
      }
    >
      <ScanInput onScan={handleScan} label={`${meta.label} scan`} />
      {statusLabel && (
        <p data-testid="gate-last-status" data-status={statusLabel}>
          {statusLabel}
        </p>
      )}
    </StationLayout>
  );
}
